import Vue from 'vue';
// eslint-disable-next-line
export const bookingsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/bookings/bookingsEventBus.js